import { makeAutoObservable } from 'mobx';

export class CommonStore {
  appTheme = '#171721';
  brandColor = '#be3491';
  isSidebarCollapsed = false;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  toggleSidebarCollapsed = () => {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  };
  setSidebarCollapsedState = (state: boolean) => {
    this.isSidebarCollapsed = state;
  };
  setIsLoading = (state: boolean) => {
    this.isLoading = state;
  };
}

const commonStore = new CommonStore();
export default commonStore;
